import React from 'react'
import {Navigate, useLocation} from 'react-router-dom'
import {useAuthentication} from 'components/providers/AuthenticationProvider'
import AppLayout from 'components/layouts/AppLayout'
import * as Api from 'lib/api'

const AuthenticatedRoute = ({component: C}) => {
  const location = useLocation()
  const {isAuthenticated, hasTenant} = useAuthentication()

  if (isAuthenticated && hasTenant) {
    if (location.pathname === '/setup') {
      return <Navigate to="/" />
    }
  }

  if (isAuthenticated && (hasTenant || location.pathname === '/setup')) {
    return (
      <AppLayout fullscreen={location.pathname === '/setup'}>
        <C api={Api} />
      </AppLayout>
    )
  }

  if (isAuthenticated) {
    return <Navigate to="/setup" />
  }

  return <Navigate to={`/login?redirect=${location.pathname}${location.search}`} />
}

export default AuthenticatedRoute
